module.exports = __webpack_public_path__ + "img/Logo_Trooperz_png.b9a7355c.png";